module.exports = __webpack_public_path__ + "img/ak2.4fffa172.webp";